<script setup lang="ts">
    defineProps<{
        recommendations: readonly string[];
    }>();
</script>

<template>
    <v-card
        class="recommendation-card"
        variant="outlined"
        rounded="md"
        data-testid="hip-spine-recommendation"
    >
        <v-card-title class="title">Recommendation</v-card-title>
        <v-card-text class="lines d-flex flex-column ga-2">
            <div v-for="(line, i) in recommendations" :key="i" class="line">
                {{ line }}
            </div>
        </v-card-text>
    </v-card>
</template>

<style scoped lang="scss">
    .recommendation-card {
        background: rgb(var(--v-theme-surface));
        border-color: rgb(var(--v-theme-grey-light-1));
        text-align: center;
    }

    .title {
        font-size: 14px;
        font-weight: 700;
        color: rgb(var(--v-theme-on-surface));
        padding-bottom: 0;
    }

    .lines {
        padding-top: 10px;
    }

    .line {
        font-size: 13px;
        color: rgb(var(--v-theme-secondary-text));
        line-height: 1.4;
    }
</style>
